import { Component, OnInit } from '@angular/core';
import { RestApiProvider } from 'src/app/services/shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SettingsService } from 'src/app/services/service.index';
import { ToastrService } from 'ngx-toastr';
import { timeout } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-clave-detail',
  templateUrl: './clave-detail.component.html',
  styleUrls: ['./clave-detail.component.css']
})
export class ClaveDetailComponent implements OnInit {
  form: FormGroup
  comisiones:any;
  comision:any;
  comision_seleccionada:number = 0;
  clave_id :number;
  aseg_id :number;
  ramos: any;
  subramos: any;
  title: any;
  verFormulario=false;
  isCreateMode=false;
  saving=false;
  deleting=false;

  constructor(
    private router: Router,
    private rest_api: RestApiProvider,
    private _activateRoute: ActivatedRoute,
    private _settings: SettingsService,
    private _toastr: ToastrService,
   ) {
    this._activateRoute.params.subscribe( params => {
      this.clave_id = params['id'];
      this.aseg_id = params['aseg_id'];
      this.cargarDatos();
    });
    this.form = new FormGroup({
      comision: new FormGroup({
        nombre : new FormControl(null, [Validators.required] ),
        comission : new FormControl(0, [Validators.required]),
        udi : new FormControl(0, [Validators.required]),
        others : new FormControl(0, [Validators.required]),
        observations : new FormControl(0, [Validators.required]),
        efective_date : new FormControl(new Date(), [Validators.required] ),
        expire_date : new FormControl(new Date(), [Validators.required]),
        periodo_inicial : new FormControl(0, [Validators.required]),
        periodo_subsecuente : new FormControl(0, [Validators.required]),
        rpf_mensual : new FormControl(0, [Validators.required]),
        rpf_bimestral : new FormControl(0, [Validators.required]),
        rpf_trimestral : new FormControl(0, [Validators.required]),
        rpf_semestral : new FormControl(0, [Validators.required]),
        rpf_anual : new FormControl(0, [Validators.required]),
        derecho : new FormControl(0, [Validators.required]),
        comission_rpf : new FormControl(0, [Validators.required]),
        udi_rpf : new FormControl(0, [Validators.required]),
        others_rpf : new FormControl(0, [Validators.required]),
        comission_derecho : new FormControl(0, [Validators.required]),
        udi_derecho : new FormControl(0, [Validators.required]),
        others_derecho : new FormControl(0, [Validators.required]),
        url : new FormControl(null),
        id : new FormControl(null),
        ramo : new FormControl(0),
        subramo : new FormControl(0),
      })
    });

  
  }

  getDate(datetime: string) {
    try {
      datetime = datetime.split('T')[0];
      return datetime;

    } catch (err) {
      console.log(err);
      return datetime;
    }
  }

  ngOnInit() {
    
  }

  // cambioAplicado: cuando la recarga ocurre después de un cambio ya confirmado (guardado o
  // eliminación), un fallo aquí NO significa que el cambio se haya perdido, por lo que se avisa
  // como advertencia y no como error, para no dar la impresión de que no se aplicó.
  async cargarDatos(cambioAplicado: string = null) {
    this.verFormulario=false;
    this.saving=false;
    this.deleting=false;
    try {
      this.comisiones = await this.rest_api.get_comisiones(this.clave_id);
    } catch (error) {
      if (cambioAplicado) {
        this._toastr.warning(cambioAplicado + ', pero no fue posible actualizar el listado desde el servidor. Recargue la página si nota información desactualizada.');
      } else {
        this._toastr.error('Ha ocurrido un error al cargar las comisiones, recargue la página nuevamente.');
      }
      return;
    }

    try {
      this.ramos = await this.rest_api.get_ramos(this.aseg_id);
      this.subramos = [];
    } catch (error) {
      if (cambioAplicado) {
        this._toastr.warning(cambioAplicado + ', pero no fue posible actualizar el catálogo de ramos. Recargue la página.');
      } else {
        this._toastr.error('Ocurrió un error al cargar los ramos');
      }
    }
  }

  cargarConfiguraciones(cambioAplicado: string = null){
    return this.cargarDatos(cambioAplicado);
  }
  newComision(){
    this.isCreateMode=true;
    this.verFormulario=true;
    this.form.reset({comision :{
      comission : 0,
      udi : 0,
      others : 0,
      observations : 0,
      periodo_inicial : 0,
      periodo_subsecuente : 0,
      rpf_mensual : 0,
      rpf_bimestral : 0,
      rpf_trimestral : 0,
      rpf_semestral : 0,
      rpf_anual : 0,
      derecho : 0,
      comission_rpf : 0,
      udi_rpf : 0,
      others_rpf : 0,
      comission_derecho : 0,
      udi_derecho : 0,
      others_derecho : 0,
      url : 0,
      ramo : 0,
      subramo : 0,
    }});
    this.comision_seleccionada = 0;
    this.subramos = [];
  }

  save(){
    this.saving=true;
    if ((this.form.get('comision') as FormGroup).get('ramo').value == 0){
      this.saving=false;
      this._toastr.error('Seleccione un ramo');
      return
    }
    if ((this.form.get('comision') as FormGroup).get('subramo').value == 0){
      this.saving=false;
      this._toastr.error('Seleccione un subramo');
      return
    }
    
    this.form.value['clave_id'] = this.clave_id;
    this.rest_api.guardar_comision(this.form.value).then(response => {
      this.saving=false;

      // El API responde siempre con HTTP 200, así que el éxito se determina por el contenido:
      // un guardado correcto devuelve la comisión serializada (objeto con id). Cualquier otra
      // cosa (cadena '{"Error":...}', HTML de error, null) es un fallo real.
      const mensajeError = this.getMensajeError(response);
      if (mensajeError) {
        this._toastr.error(mensajeError);
        return
      }

      Swal.fire(
        'Guardado exitoso',
        'Comisión guardada correctamente.',
        'success'
      );
      this.isCreateMode = false;
      this.verFormulario = false;
      this.comision_seleccionada = 0;
      this.form.reset();
      this.cargarConfiguraciones('La configuración se guardó');
    }, (error: any) => {
      this.saving=false;

      // 502/504: no hubo respuesta del backend, el guardado pudo haberse aplicado igualmente.
      // Afirmar que no se guardó sería tan engañoso como el error falso que se está corrigiendo.
      if (error && (error.status === 502 || error.status === 504)) {
        this._toastr.warning('No se recibió confirmación del servidor. Recargue la página y verifique si el cambio se aplicó antes de reintentar.');
        return
      }

      this._toastr.error(this.getMensajeError(error && error.error) || 'No se pudo guardar la configuración.');
    });
  }

  // Devuelve null si la respuesta corresponde a un guardado exitoso, o el mensaje a mostrar
  // si el API reportó un error. No se compara contra cadenas literales porque el backend
  // reenvía el cuerpo del error tal cual (JSON serializado, HTML de un 500, etc.).
  private getMensajeError(response: any): string {
    let data: any = response;

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return 'No se pudo guardar la configuración.';
      }
    }

    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      return 'No se pudo guardar la configuración.';
    }

    const detalle = data['Error'] || data['error'];
    if (detalle) {
      // El orden importa: 'SubRamos matching...' contiene a 'Ramos matching...' como subcadena.
      if (String(detalle).indexOf('SubRamos matching query does not exist') !== -1) {
        return 'Ha seleccionado un Subramo inválido';
      }
      if (String(detalle).indexOf('Ramos matching query does not exist') !== -1) {
        return 'Ha seleccionado un Ramo inválido';
      }
      return 'No se pudo guardar la configuración: ' + detalle;
    }

    if (data['id'] == null) {
      return 'No se pudo guardar la configuración.';
    }

    return null;
  }

  // Descripción legible de una configuración, con el mismo formato del selector, para que el
  // usuario confirme exactamente sobre cuál está actuando.
  private describirComision(comision: any): string {
    if (!comision) {
      return 'seleccionada';
    }
    const partes = [comision['subramo_name'], 'ID ' + comision['id'], comision['nombre']]
      .filter(parte => parte !== null && parte !== undefined && parte !== '');
    return partes.join(' / ');
  }

  eliminarComision() {
    if (!this.comision_seleccionada || this.comision_seleccionada == 0) {
      this._toastr.error('Seleccione la configuración que desea eliminar');
      return
    }

    const comision_id = this.comision_seleccionada;
    const seleccionada = (this.comisiones || []).filter(com => com['id'] == comision_id)[0];

    Swal.fire({
      title: '¿Eliminar esta configuración?',
      text: 'Se eliminará únicamente la configuración ' + this.describirComision(seleccionada) +
            '. Dejará de aplicarse en nuevos registros y no podrá recuperarse.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (!result || !result.value) {
        return
      }
      this.borrarComision(comision_id);
    });
  }

  private borrarComision(comision_id: number) {
    this.deleting = true;
    this.rest_api.eliminar_comision(comision_id).then(response => {
      this.deleting = false;

      const mensajeError = this.getMensajeErrorEliminacion(response);
      if (mensajeError) {
        this._toastr.error(mensajeError);
        return
      }

      Swal.fire(
        'Configuración eliminada',
        'La configuración dejará de aplicarse en nuevos registros.',
        'success'
      );
      this.isCreateMode = false;
      this.verFormulario = false;
      this.quitarComisionDelListado(comision_id);
      this.form.reset();
      // La recarga sólo resincroniza el resto del catálogo (las vigencias de las demás
      // configuraciones las recalcula el servidor); el listado en pantalla ya está al día.
      this.cargarConfiguraciones('La configuración se eliminó');
    }, (error: any) => {
      this.deleting = false;

      // 502/504: no hubo respuesta del backend; la eliminación pudo haberse aplicado igualmente,
      // así que no se afirma que la configuración sigue existiendo.
      if (error && (error.status === 502 || error.status === 504)) {
        this._toastr.warning('No se recibió confirmación del servidor. Recargue la página y verifique si la configuración fue eliminada antes de reintentar.');
        return
      }

      // Ya no existe: el listado en pantalla está desactualizado, se refresca para reflejarlo.
      if (error && error.status === 404) {
        this._toastr.warning('La configuración ya no existe. Se actualizó el listado.');
        this.verFormulario = false;
        this.quitarComisionDelListado(comision_id);
        this.form.reset();
        this.cargarConfiguraciones();
        return
      }

      this._toastr.error(this.getMensajeErrorEliminacion(error && error.error) || 'No se pudo eliminar la configuración.');
    });
  }

  // Retira del listado en memoria una configuración que el servidor ya confirmó eliminada, para
  // que el selector deje de ofrecerla de inmediato sin esperar a la recarga. Si la recarga falla,
  // el listado en pantalla sigue siendo correcto en lugar de mostrar algo que ya no existe.
  private quitarComisionDelListado(comision_id: number) {
    this.comisiones = (this.comisiones || []).filter(com => com['id'] != comision_id);
    this.comision = null;
    this.comision_seleccionada = 0;
    this.subramos = [];
  }

  // Mismo criterio que getMensajeError: la cadena de servicios puede responder 200 con el cuerpo
  // de un error, así que el éxito se determina por la forma de la respuesta y no por el status.
  private getMensajeErrorEliminacion(response: any): string {
    let data: any = response;

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return 'No se pudo eliminar la configuración.';
      }
    }

    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      return 'No se pudo eliminar la configuración.';
    }

    const detalle = data['Error'] || data['error'];
    if (detalle) {
      return 'No se pudo eliminar la configuración: ' + detalle;
    }

    if (data['eliminada'] !== true) {
      return 'No se pudo eliminar la configuración.';
    }

    return null;
  }

  cancel() {
    this.router.navigate(['/claves-agente']);
  }

  goBack() {
    this.router.navigate(['/claves-agente']);
  }

  changeComision(){
    this.isCreateMode=false;
    this.verFormulario=true;
    this.comision = this.comisiones.filter(com => com['id'] == this.comision_seleccionada);
    if(this.comision_seleccionada==0){
      this.verFormulario=false;
      this.form.reset({comision :{
        comission : 0,
        udi : 0,
        others : 0,
        observations : 0,
        periodo_inicial : 0,
        periodo_subsecuente : 0,
        rpf_mensual : 0,
        rpf_bimestral : 0,
        rpf_trimestral : 0,
        rpf_semestral : 0,
        rpf_anual : 0,
        derecho : 0,
        comission_rpf : 0,
        udi_rpf : 0,
        others_rpf : 0,
        comission_derecho : 0,
        udi_derecho : 0,
        others_derecho : 0,
        url : 0,
        ramo : 0,
        subramo : 0,
      }});
      this.comision_seleccionada = 0;
      this.subramos = [];
    }
    if (this.comision && this.comision.length > 0){
      this.comision = this.comision[0];
      (this.form.get('comision') as FormGroup).reset(this.comision);
      (this.form.get('comision') as FormGroup).get('efective_date').setValue(this.getDate(this.comision['efective_date']));
      (this.form.get('comision') as FormGroup).get('expire_date').setValue(this.getDate(this.comision['expire_date']));
    }      
    this.changeRamo();  
  }

  changeRamo() {
    console.log(this.form.value);
    
    return new Promise((resolve,reject)=>{
      this.rest_api.get_subramos(this.aseg_id, (this.form.get('comision') as FormGroup).get('ramo').value).then(response => {
        this.subramos = response;
        this._toastr.success('Subamos cargados');
        resolve(true);
      }, error => {
        reject(error)
      })
      .catch(err => {
        reject(err)
      });
    });
    
  }

  get nombreNoValido(){
    return (this.form.get('comision') as FormGroup).get('nombre').invalid && (this.form.get('comision') as FormGroup).get('nombre').touched;
  }
  get comissionNoValido(){
    return (this.form.get('comision') as FormGroup).get('comission').invalid && (this.form.get('comision') as FormGroup).get('comission').touched;
  }
  get udiNoValido(){
    return (this.form.get('comision') as FormGroup).get('udi').invalid && (this.form.get('comision') as FormGroup).get('udi').touched;
  }
  get othersNoValido(){
    return (this.form.get('comision') as FormGroup).get('others').invalid && (this.form.get('comision') as FormGroup).get('others').touched;
  }
  get observationsNoValido(){
    return (this.form.get('comision') as FormGroup).get('observations').invalid && (this.form.get('comision') as FormGroup).get('observations').touched;
  }
  get efective_dateNoValido(){
    return (this.form.get('comision') as FormGroup).get('efective_date').invalid && (this.form.get('comision') as FormGroup).get('efective_date').touched;
  }
  get expire_dateNoValido(){
    return (this.form.get('comision') as FormGroup).get('expire_date').invalid && (this.form.get('comision') as FormGroup).get('expire_date').touched;
  }
  get periodo_inicialNoValido(){
    return (this.form.get('comision') as FormGroup).get('periodo_inicial').invalid && (this.form.get('comision') as FormGroup).get('periodo_inicial').touched;
  }
  get periodo_subsecuenteNoValido(){
    return (this.form.get('comision') as FormGroup).get('periodo_subsecuente').invalid && (this.form.get('comision') as FormGroup).get('periodo_subsecuente').touched;
  }
  get rpf_mensualNoValido(){
    return (this.form.get('comision') as FormGroup).get('rpf_mensual').invalid && (this.form.get('comision') as FormGroup).get('rpf_mensual').touched;
  }
  get rpf_bimestralNoValido(){
    return (this.form.get('comision') as FormGroup).get('rpf_bimestral').invalid && (this.form.get('comision') as FormGroup).get('rpf_bimestral').touched;
  }
  get rpf_trimestralNoValido(){
    return (this.form.get('comision') as FormGroup).get('rpf_trimestral').invalid && (this.form.get('comision') as FormGroup).get('rpf_trimestral').touched;
  }
  get rpf_semestralNoValido(){
    return (this.form.get('comision') as FormGroup).get('rpf_semestral').invalid && (this.form.get('comision') as FormGroup).get('rpf_semestral').touched;
  }
  get rpf_anualNoValido(){
    return (this.form.get('comision') as FormGroup).get('rpf_anual').invalid && (this.form.get('comision') as FormGroup).get('rpf_anual').touched;
  }
  get derechoNoValido(){
    return (this.form.get('comision') as FormGroup).get('derecho').invalid && (this.form.get('comision') as FormGroup).get('derecho').touched;
  }
  get comission_rpfNoValido(){
    return (this.form.get('comision') as FormGroup).get('comission_rpf').invalid && (this.form.get('comision') as FormGroup).get('comission_rpf').touched;
  }
  get udi_rpfNoValido(){
    return (this.form.get('comision') as FormGroup).get('udi_rpf').invalid && (this.form.get('comision') as FormGroup).get('udi_rpf').touched;
  }
  get others_rpfNoValido(){
    return (this.form.get('comision') as FormGroup).get('others_rpf').invalid && (this.form.get('comision') as FormGroup).get('others_rpf').touched;
  }
  get comission_derechoNoValido(){
    return (this.form.get('comision') as FormGroup).get('comission_derecho').invalid && (this.form.get('comision') as FormGroup).get('comission_derecho').touched;
  }
  get udi_derechoNoValido(){
    return (this.form.get('comision') as FormGroup).get('udi_derecho').invalid && (this.form.get('comision') as FormGroup).get('udi_derecho').touched;
  }
  get others_derechoNoValido(){
    return (this.form.get('comision') as FormGroup).get('others_derecho').invalid && (this.form.get('comision') as FormGroup).get('others_derecho').touched;
  }
  get subramoNoValido(){
    return (this.form.get('comision') as FormGroup).get('subramo').invalid && (this.form.get('comision') as FormGroup).get('subramo').touched;
  }
  get ramoNoValido(){
    return (this.form.get('comision') as FormGroup).get('ramo').invalid && (this.form.get('comision') as FormGroup).get('ramo').touched;
  }

}


